// actions
import { dispatchSetWindowDimension } from '../../components/main/root.action'
// effect
import { effectOnWindowResize } from '../../components/main/root.effect'

window.onresize = () =>
  effectOnWindowResize({ width: window.innerWidth, height: window.innerHeight })

dispatchSetWindowDimension(window.innerWidth, window.innerHeight)
